import React from 'react';
import Icon from '../../../components/AppIcon';

const DishStatsPanel = ({ stats = [], loading = false, error = null, onRefresh }) => {
  const currentMonth = stats?.length
    ? new Date()?.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })
    : '';

  const maxAR = stats?.length > 0 ? Math.max(...stats?.map(s => s?.ar_uses || 0), 1) : 1;

  return (
    <div className="dish-stats-panel bg-card border border-border rounded-lg p-4 md:p-6 shadow-warm">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
            Statistiques des Plats
          </h3>
          {currentMonth && (
            <p className="text-xs text-muted-foreground mt-0.5">
              {currentMonth}
            </p>
          )}
        </div>
        <button
          type="button"
          onClick={onRefresh}
          disabled={loading}
          className="p-2 rounded-lg bg-muted hover:bg-muted/80 transition-smooth touch-target disabled:opacity-50"
          title="Actualiser"
        >
          <Icon name="RefreshCw" size={16} color="var(--color-foreground)" />
        </button>
      </div>
      {loading ? (
        <div className="flex items-center justify-center py-12">
          <div className="flex flex-col items-center gap-3">
            <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
            <p className="text-sm text-muted-foreground">Chargement des statistiques…</p>
          </div>
        </div>
      ) : error ? (
        <div className="flex items-center gap-3 p-4 bg-destructive/10 rounded-lg">
          <Icon name="AlertCircle" size={18} color="var(--color-destructive)" />
          <p className="text-sm text-destructive">{error}</p>
        </div>
      ) : stats?.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 gap-3">
          <div className="w-12 h-12 bg-muted rounded-full flex items-center justify-center">
            <Icon name="BarChart2" size={24} color="var(--color-muted-foreground)" />
          </div>
          <p className="text-sm text-muted-foreground text-center">
            Aucune statistique disponible.<br />
            Les données apparaîtront dès qu'un client utilisera la RA.
          </p>
        </div>
      ) : (
        <div className="space-y-3 max-h-[560px] overflow-y-auto pr-1">
          {stats?.map((dish) => {
            const arUses = dish?.ar_uses || 0;
            const pct = Math.round((arUses / maxAR) * 100);
            return (
              <div key={dish?.id} className="flex items-center gap-3">
                <span
                  className="text-sm font-body text-foreground flex-shrink-0 w-36 truncate"
                  title={dish?.dish_name}
                >
                  {dish?.dish_name}
                </span>
                <div className="flex-1 h-5 bg-muted rounded-md overflow-hidden">
                  <div
                    className="h-full bg-accent rounded-md transition-all duration-500"
                    style={{ width: `${pct}%` }}
                  />
                </div>
                <span className="text-xs font-data text-muted-foreground flex-shrink-0 w-8 text-right">
                  {arUses}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DishStatsPanel;
